import { atom } from 'jotai';

export const isLogoutErrorDialogOpenAtom = atom(false);
